import {Component, Input, OnInit} from '@angular/core';
import {PAGINATION_ORDER, TYPE_DATA} from '../../models/table';
import {TableBase} from './table-base';

@Component({
  selector: 'cmp-table',
  template: `<div class="row">
  <div class="col-md-12">

    <!-- MAIN TABLE -->
    <div class="bg-light border-top border-bottom p-2 clearfix">
      <div class="mt-1 float-left">{{table.title}}</div>

      <div class="float-left">
        <ng-content select="[left]"></ng-content>
      </div>

      <span class="float-right">
        <span class="float-left ml-1">
          <cmp-animated-search *ngIf="table.onSearch" (delayChange)="changeInputSearch($event)"
                               [(model)]="table.filter "></cmp-animated-search>
        </span>
        <div ngbDropdown placement="bottom-right" class="d-inline-block " *ngIf="!notData && isPaginate ">
          <button class="btn btn-outline-secondary btn-xs bg-white ml-1" id="dropdownBasic2" ngbDropdownToggle>
            <i class="fa fa-list-ul"></i>
            {{table.pagination.maxRows}}
          </button>
          <ul ngbDropdownMenu aria-labelledby="dropdownBasic2">
            <li (click)="changeMaxRows(item)"
                *ngFor="let item of [10 , 15, 30 , 50 ,100]"
                class="dropdown-item">
              {{item}}
            </li>
          </ul>
        </div>
      </span>
      <div class="float-right ">
        <ng-content select="[right]"></ng-content>
      </div>
    </div>

    <!-- TABLES -->
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th class="text-center" *ngIf="table.onSelected" width="50px">
              <cmp-input-check [isDisabled]="notData" (modelChange)="selectAll($event)"></cmp-input-check>
            </th>
            <ng-template ngFor let-key let-i="index" [ngForOf]="table.header">
              <th scope="col " *ngIf="!key.hidden"
                  (click)="addOffset(key.keyData)"
                  [class]="key.class">
                <div *ngIf="!key.hiddenTitle"
                     [class.input-group]="key.sortable && table.pagination.offset  === key.keyData">
                  <span class="text-truncate col-9 m-0 p-0"> {{key.title?key.title.toUpperCase():''}}</span>
                  <div class="input-group-append input-group-btn col-2  text-right"
                       *ngIf="key.sortable && table.pagination.offset === key.keyData">
                    <i class="fa " [class.fa-sort-desc]="table.pagination.order === orderPagination.DESCENDENTE"
                       [class.fa-sort-asc]="table.pagination.order === orderPagination.ASCENDENTE">
                    </i>
                  </div>
                </div>
              </th>
            </ng-template>
          </tr>
        </thead>
        <tbody *ngIf="table.isLoading; else false_loading">
          <tr>
            <td colspan="100%">
              <div>
                <cmp-loading></cmp-loading>
              </div>
            </td>
          </tr>
        </tbody>
        <ng-template #false_loading>
          <ng-template [ngIf]="!viewNotResult">
            <ng-content select="[inTable]"></ng-content>
            <tbody *ngIf="!notData && !isLoading">
              <tr *ngIf="table.isFiltered">
                <td *ngIf="table.onSelected" width="50px">
                  <i class="fa fa-minus-square text-light"></i>
                </td>
                <ng-template ngFor let-key let-i="index" [ngForOf]="table.header">
                  <td scope="col" *ngIf="!key.hidden && key.isFiltered">
                    <cmp-input-table
                      (delayChange)="reloadFilter($event, key)"
                      [key]="key"
                      [(model)]="key.filter">
                    </cmp-input-table>
                  </td>
                </ng-template>
              </tr>
              <ng-template ngFor let-data let-o="index" [ngForOf]="table.results.list">
                <tr>
                  <td class="align-middle text-center" *ngIf="table.onSelected" width="50px">
                    <cmp-input-check
                      (modelChange)="tableChange.emit(this.table)"
                      [(model)]="data._selected">
                    </cmp-input-check>
                  </td>
                  <ng-template ngFor let-key let-i="index" [ngForOf]="table.header">
                    <ng-container *ngIf="!key.hidden">
                      <td [class]="getClassTD(key, data)"
                          (click)="actionRedirect(key, data)"
                          [title]="key.tooltip?key.tooltip:key.title">
                        <ng-template [ngIf]="key.type_data === enum_type_data.TEMPLATE"
                                     [ngIfElse]="defaultTemplate">
                          <ng-container *ngTemplateOutlet="columnsTemplates[key.keyData]; context: getContext(data)">
                          </ng-container>
                        </ng-template>
                        <ng-template #defaultTemplate>
                          <cmp-body-table
                            [row]="data"
                            [key]="key"
                            [model]="data[key.keyData]"
                            (onActionItem)="actionItem($event)">
                          </cmp-body-table>
                        </ng-template>
                        <ng-template
                          [ngIf]="key.labels && key.labels.key && data[key.labels.key] && data[key.labels.key].length">
                          <cmp-label *ngFor="let labels of data[key.labels.key]" [type]="key.labels.type">
                            {{labels[key.labels.title]}}
                          </cmp-label>
                        </ng-template>
                      </td>
                    </ng-container>
                  </ng-template>
                </tr>

              </ng-template>

            </tbody>
          </ng-template>
          <tbody *ngIf="viewNotResult">
            <tr>
              <td colspan="100%">

                <cmp-not-results
                  [noResults]="{
                    customRobotClass:'mt-2 mb-2',
                    errorMessage: 'Not Results',
                    isRobotSnippet: true,
                     robotWidthPx: 150
                     }">
                </cmp-not-results>
              </td>
            </tr>
          </tbody>
        </ng-template>

        <tfoot *ngIf="!notData && isPaginate">
          <tr>
            <td colspan="100%" *ngIf="table.results && table.results.total_resources">
              <div class="input-group input-group-sm float-left " style="max-width: 150px">
                <div class="input-group-prepend"
                     *ngIf="totalPages > 0 && totalPages !== table.pagination.page &&  table.pagination.page <= totalPages  && isValidPage"
                     (click)="nextPreviousPage(false)">
                  <span class="input-group-text fa fa-chevron-left"></span>
                </div>
                <input
                  [min]="1"
                  [max]="totalPages"
                  [type]="'number'"
                  [class.is-valid]="isValidPage"
                  [class.is-invalid]="!isValidPage"
                  (ngModelChange)="reloadPage()"
                  class="form-control form-control-sm text-center no-spinners"
                  [(ngModel)]="table.pagination.page">

                <div class="input-group-append"
                     *ngIf="table.pagination.page < totalPages"
                     (click)="nextPreviousPage()">
                  <span class="input-group-text fa fa-chevron-right">
                  </span>
                </div>
              </div>
              <div class="pt-1 ml-2 float-left">
                <small>Total pages:</small>
                <span class="text-secondary pl-1">{{totalPages}}</span>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

  </div>
</div>


<ng-template>

  <div class="input-group input-group-sm float-left " style="max-width: 150px">
    <div class="input-group-prepend"
         *ngIf="totalPages > 0 && table.pagination.page <= totalPages  && isValidPage"
         (click)="nextPreviousPage(false)">
      <span class="input-group-text fa fa-chevron-left"></span>
    </div>
    <input
      [min]="1"
      [max]="totalPages"
      [type]="'number'"
      [class.is-valid]="isValidPage"
      [class.is-invalid]="!isValidPage"
      (ngModelChange)="reloadPage()"
      class="form-control form-control-sm text-center no-spinners"
      [(ngModel)]="table.pagination.page">

    <div class="input-group-append"
         *ngIf="table.pagination.page < totalPages"
         (click)="nextPreviousPage()">
      <span class="input-group-text fa fa-chevron-right">
      </span>
    </div>
  </div>
  <div class="pt-1 ml-2 float-left">
    <small>Total pages:</small>
    <span class="text-secondary pl-1">{{totalPages}}</span>
  </div>
</ng-template>
`,
  styles: [`.table thead th{vertical-align:bottom;border-top:0;border-bottom:2px solid #327abd}table thead th{padding-top:20px;padding-bottom:5px;font-weight:500}table tbody tr td{cursor:pointer;color:#6c757d;padding:5px!important;font-weigth:200!important}table tbody tr:hover td{color:#327abd}.input-group{justify-content:space-between;align-items:center}.input-group-btn .btn{background:0 0}.loadingTable{position:absolute;left:0;right:0}.pAb{top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;position:absolute}`]
})
export class TableComponent extends TableBase implements OnInit {
  orderPagination = PAGINATION_ORDER;
  @Input() isPaginate = true;
  @Input() isNotResults: any;
  @Input() isBody = true;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  selectAll(select) {
    this.table.results.list.forEach((a) => a._selected = select);
  }


  actionItem(e) {
    this.onActionItem.emit(e);
  }

  reloadFilter(a, key) {
    if (typeof a !== 'undefined') {
      key.filter = a;
    }
    this.reloadData();
  }

  get notData() {
    return !(this.table.results && this.table.results.list && this.table.results.list.length);
  }

  addOffset(newOffset) {
    if (newOffset === this.table.pagination.offset && this.table.pagination.order === PAGINATION_ORDER.ASCENDENTE) {
      this.table.pagination.order = PAGINATION_ORDER.DESCENDENTE;
    } else if (newOffset === this.table.pagination.offset && this.table.pagination.order === PAGINATION_ORDER.DESCENDENTE) {
      this.table.pagination.order = PAGINATION_ORDER.ASCENDENTE;
      this.table.pagination.offset = 'id';
    } else {
      this.table.pagination.offset = newOffset;
    }

    this.reloadData();
  }

  actionRedirect(key, row) {
    if (key.type_data === TYPE_DATA.TEMPLATE) {
      return;
    }

    if (key.type_data !== TYPE_DATA.ACTION && !key.onAction) {
      this.onActionRedirect.emit(row);
    }
  }

  getContext(row) {
    return {$implicit: row};
  }

  changeInputSearch($event) {
    this.table.filter = $event;
    this.reloadData();
  }

  get viewNotResult() {
    if (typeof this.isNotResults !== 'undefined' && this.isNotResults !== null) {
      return this.isNotResults;
    }
    return this.notData;
  }
}
